import React from 'react';
import IconVerification24 from '@warp-ds/icons/react/verification-24';

export type ProfileProps = {
    profile:
        | {
              email: string;
              name: string;
              avatar: string;
              memberSince: string;
              description?: string;
              localProfileId?: string;
              verified: boolean;
          }
        | undefined;
};

export default function Profile({ profile }: ProfileProps): React.ReactElement {
    if (profile === undefined) {
        return <React.Fragment />;
    }

    return (
        <div className="flex p-16 text-left rounded-8 s-bg-info-default border">
            <img
                className="mr-16 w-[62.5px] h-[62.5px] rounded-full"
                src={profile.avatar}
                alt={profile.name}
            />
            <div className="flex flex-col justify-center text-left">
                <div className="flex items-center">
                    <p className="mb-0 text-m font-bold">{profile.name}</p>
                    {profile.verified && (
                        <IconVerification24
                            width="14px"
                            height="14px"
                            className="ml-4 s-text-link"
                        />
                    )}
                </div>
                <p className="mb-0 text-s">{profile.email}</p>
            </div>
        </div>
    );
}
